import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ConnectionDetails from './ConnectionDetailsBlock';
import ConnectionDetailsBlockData from 'Models/Content/ConnectionDetailsBlockData';

export default class ConnectionDetailsBlock extends EpiComponent<ConnectionDetailsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {

    return (
        <div className="connection-details-block">
            <ConnectionDetails iContent={this.props.data} context={this.getContext()} />
        </div>
    )
  }
}

